import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { Image, ImageWrap, Root } from './SearchNoResult.styled';

const I18N_SCOPE = 'SearchDialog.Empty';

export interface SearchNoResultProps {
  query?: string;
}

export const SearchNoResult = ({ query: _ }: SearchNoResultProps) => {
  const { t } = useTranslation();

  return (
    <Root>
      <Typography variant="body1" gutterBottom>
        {t(`${I18N_SCOPE}.title`)}
      </Typography>

      <ImageWrap>
        <Image />
      </ImageWrap>
    </Root>
  );
};
